import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router';
import { I18n as I } from 'react-redux-i18n';

import { formatCurrency } from 'vdlib';
import Portlet from '../layout/Portlet';
import Counter from './Counter';
import AuctionStatusCellRenderer from '../tables/datagrid-columns/AuctionStatusCellRenderer';
import BidsCellRenderer from '../tables/datagrid-columns/BidsCellRenderer';

const columnDefs = [
  {
    title: I.t('SN'),
    field: 'ID',
    align: 'center',
  },
  {
    title: I.t('PART_NO'),
    field: 'PartNumber',
    align: 'center',
  },
  {
    title: I.t('DESCRIPTION'),
    field: 'PartDescription',
  },
  {
    title: I.t('OFFERS'),
    field: 'offers',
    render: (_, record) => <BidsCellRenderer {...record} />,
  },
  {
    title: I.t('BRAND'),
    field: 'VehicleBrand',
    align: 'center',
  },
  {
    title: I.t('MODEL'),
    field: 'VehicleModel',
    align: 'center',
  },
  {
    title: I.t('INITIAL_PRICE_SHORT'),
    field: 'PartPrice',
    ρενδερ: (_, record) => formatCurrency(record.PartPrice),
    align: 'center',
  },
  {
    title: I.t('STATUS'),
    width: 55,
    align: 'center',
    render: (_, record) => <AuctionStatusCellRenderer {...record} />,
  },
];

const InsuranceDashboard = ({
  Auctions,
  TotalActiveAuctionAmount,
  TotalActiveAuctionCount,
  TotalDispatchProblemAuctionCount,
  TotalForAcceptAuctionAmount,
  TotalForAcceptAuctionCount,
  TotalForApproveAuctionAmount,
  TotalForApproveAuctionCount,
  TotalFinishedAuctionAmount,
  TotalFinishedAuctionCount,
  TotalForSelectAuctionAmount,
  TotalForSelectAuctionCount,
}) => {
  const counterClassName = 'col-md-4 col-sm-6 col-12';
  //const containerClassName4 = 'col-md-3 col-sm-6 col-12';

  return (
    <div>
      <hr className="clear" />
      <div className="row">
        <Link to="/auctions" className={counterClassName}>
          <Counter
            colorClassName="green"
            icon="line-chart"
            title={I.t('CURRENT')}
            value={TotalActiveAuctionCount}
            amount={formatCurrency(TotalActiveAuctionAmount)}
          />
        </Link>
        <Link to="/auctions/for-selection" className={counterClassName}>
          <Counter
            colorClassName="yellow"
            icon="trophy"
            title={I.t('FOR_SELECTION')}
            value={TotalForSelectAuctionCount}
            amount={formatCurrency(TotalForSelectAuctionAmount)}
          />
        </Link>
        <Link to="/auctions/completed" className={counterClassName}>
          <Counter
            colorClassName="blue"
            icon="thumbs-up"
            title={I.t('COMPLETED_PL_FEM')}
            value={TotalFinishedAuctionCount}
            amount={formatCurrency(TotalFinishedAuctionAmount)}
          />
        </Link>
      </div>
      <div className="row">
        <Link to="/auctions/pending-approval" className={counterClassName}>
          <Counter
            colorClassName="blue"
            icon="legal"
            title={I.t('PENDING_APPROVAL')}
            value={TotalForApproveAuctionCount}
            amount={formatCurrency(TotalForApproveAuctionAmount)}
          />
        </Link>
        <Link to="/auctions/for-acceptance" className={counterClassName}>
          <Counter
            colorClassName="red"
            icon="check"
            title={I.t('FOR_ACCEPTANCE')}
            value={TotalForAcceptAuctionCount}
            amount={formatCurrency(TotalForAcceptAuctionAmount)}
          />
        </Link>
        <Link to="/auctions/dispatch-problem" className={counterClassName}>
          <Counter
            colorClassName="red"
            icon="exclamation"
            title={I.t('DISPATCH_PROBLEM')}
            value={TotalDispatchProblemAuctionCount}
          />
        </Link>
      </div>

      {/* <Portlet title={I.t('CURRENT_AUCTIONS_C')}>
        <Table columns={columnDefs} data={Auctions} />
      </Portlet> */}
    </div>
  );
};

export default InsuranceDashboard;
